import { PageBody } from 'modules';
import React from 'react';
import { Alert } from 'react-bootstrap';
import logoMax from 'assets/logoMax.png';

const OnlineFormNotFound = () => {
  return (
    <PageBody>
      <div className="text-center mb-5">
        <div>
          <img
            src={logoMax}
            alt="Bonato"
            className="mt-5 mb-2"
            style={{ width: '80%', maxWidth: 400, margin: 'auto' }}
          />
        </div>
        <Alert variant="danger">Hľadaný formulár nebol nájdený</Alert>
      </div>
    </PageBody>
  );
};

export default OnlineFormNotFound;
